import { schema } from 'normalizr';

export const impactAssessmentProductSchema = new schema.Entity('impactAssessmentProducts', {}, { idAttribute: 'ImpactAssessmentProductId' });
export const impactAssessmentCandidateProductSchema = new schema.Entity('impactAssessmentProducts', {}, { idAttribute: 'ImpactAssessmentProductId' });
export const impactAssessmentProductListSchema = [impactAssessmentProductSchema];
